import type { StatusName } from '../types';

const statusStyles: Record<string, string> = {
  'Pending BHSD Approval': 'bg-orange-100 text-orange-800',
  'Pending Onyx Approval': 'bg-purple-100 text-purple-800',
  'Pending Payment':       'bg-blue-100 text-blue-800',
  'Paid':                  'bg-green-100 text-green-800',
  'Rejected':              'bg-red-100 text-red-800',
  'Voided':                'bg-gray-100 text-gray-600',
};

interface Props {
  status: StatusName | string;
}

export default function StatusBadge({ status }: Props) {
  const cls = statusStyles[status] ?? 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${cls}`}>
      {status}
    </span>
  );
}
